var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"col-left"},[_c('user-card-container'),_c('notifications-container',{attrs:{"readonly":true}})],1),_c('div',{staticClass:"col-center"},[_c('activity-container')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }